import { Link } from 'react-router-dom';
import logo from '../../../studentassets/logo.png';
import { SlSocialFacebook } from "react-icons/sl";
import { LuTwitter } from "react-icons/lu";
import { FaLinkedinIn } from "react-icons/fa6";
import { GrInstagram } from "react-icons/gr";


export default function Footer() {
    return (
        <>
            <div className="rts-footer-area bg-footer footer-one">
                <div className="container rts-section-gapTop pb--100 pb_sm--30">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="footer-one-main-wrapper">

                                <div className="footer-singl-wized left-logo">
                                    <div className="head">
                                        <Link to="#">
                                            <img src={logo} alt="logo" width="120" />
                                        </Link>
                                    </div>
                                    <div className="body">
                                        <p className="dsic">
                                            Demo is an artificial intelligence trained to automate
                                            important tasks such writing optimized product descriptions.
                                        </p>
                                        <div className="social-style-two">
                                            <ul>
                                                <li>
                                                    <Link to="#"><SlSocialFacebook /></Link>
                                                </li>
                                                <li>
                                                    <Link to="#"><LuTwitter /></Link>
                                                </li>
                                                <li>
                                                    <Link to="#"><FaLinkedinIn /></Link>
                                                </li>
                                                <li>
                                                    <Link to="#"><GrInstagram /></Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="footer-singl-wized">
                                    <div className="head">
                                        <h6 className="title">Company</h6>
                                    </div>
                                    <div className="body">
                                        <ul className="menu">
                                            <li><Link to="/about">About Us</Link></li>
                                            <li><Link to="/contact">Contact Us</Link></li>
                                            <li><Link to="#">Terms & Conditions</Link></li>
                                            <li><Link to="#">Privacy Policy</Link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="footer-singl-wized">
                                    <div className="head">
                                        <h6 className="title">Use Cases</h6>
                                    </div>
                                    <div className="body">
                                        <ul className="menu">
                                            <li><Link to="/pricing">Pricing</Link></li>
                                            <li><Link to="/faq">FAQ</Link></li>
                                            <li><Link to="/feature">Features</Link></li>
                                            <li><Link to="/blog">Blog</Link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="footer-singl-wized input-area">
                                    <div className="head">
                                        <h6 className="title"> Update</h6>
                                    </div>
                                    <div className="body">

                                        {/* <form action="#">
                                            <div className="input-area-fill">
                                                <input type="email" placeholder="Enter Your Email" required="" />
                                                <button>Subscribe</button>
                                            </div>
                                        </form> */}

                                        <p className="disc">
                                            Subscribe our newsletter for future updates. don’t worry we
                                            don’t spam your email address
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="copy-right-start-two">
                                <p>
                                    <Link to="/" target="_blank">Cuzysolve &copy; </Link>
                                    <script></script>
                                    2025. All Rights Reserved.
                                </p>
                                <ul>
                                    <li><Link to="/termscondition">Terms</Link></li>
                                    <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* backto top start */}
            <div className="progress-wrap">
                <svg
                    className="progress-circle svg-content"
                    width="100%"
                    height="100%"
                    viewBox="-1 -1 102 102"
                >
                    <path
                        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                        style={{
                            transition: "stroke-dashoffset 10ms linear",
                            strokeDasharray: "307.919, 307.919",
                            strokeDashoffset: "307.919",
                        }}
                    />
                </svg>
            </div>

        </>
    )
}
